import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDateFormat',
  standalone: true,
})
export class CustomDateFormatPipe implements PipeTransform {
  transform(value: string, format: string): string {
    if (!value) return '-';

    let timeZone = '+00:00';
    const regex = /([\+\-]\d{2}:\d{2})$/;
    const match = value.match(regex);

    if (match && match[1]) timeZone = match[1];

    return formatDate(value, format, 'en', timeZone);
  }
}
